import React, { Component } from "react";

import "./Navigation.css";
// Font Awesome import
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDesktop,
  faCar,
  faDollarSign,
  faClock,
  faBoxes,
  faAddressCard,
  faClipboardList
} from "@fortawesome/free-solid-svg-icons";

import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

class Navigation extends Component {
  highlightItem = index => {
    if (index === this.props.activeMenu) {
      return "active";
    }
    return "";
  };
  render() {
    return (
      <div className="main-sidebar-nav">
        <ul>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard"
              className={this.highlightItem("main")}
            >
              Main
            </Link>
          </li>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard"
              className={this.highlightItem("dashboard")}
            >
              <FontAwesomeIcon icon={faDesktop} />
              Dashboard
            </Link>
          </li>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard/basicinfo"
              className={this.highlightItem("basicinfo")}
            >
              <FontAwesomeIcon icon={faAddressCard} />
              Basic Info
            </Link>
          </li>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard/packages"
              className={this.highlightItem("packages")}
            >
              <FontAwesomeIcon icon={faBoxes} />
              Packages / Plans
            </Link>
          </li>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard/payments"
              className={this.highlightItem("payments")}
            >
              <FontAwesomeIcon icon={faDollarSign} />
              Payment / Balances
            </Link>
          </li>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard/lessons"
              className={this.highlightItem("lessons")}
            >
              <FontAwesomeIcon icon={faCar} />
              Lessons
            </Link>
          </li>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard/roadtests"
              className={this.highlightItem("roadtests")}
            >
              <FontAwesomeIcon icon={faClipboardList} />
              Road Tests
            </Link>
          </li>
          <li className="menu-element">
            <Link
              to="/app/student-dashboard/fivehourclass"
              className={this.highlightItem("fivehour")}
            >
              <FontAwesomeIcon icon={faClock} />
              5hr. Class Info
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default withRouter(Navigation);
